import { t } from '@lingui/core/macro'

export function getCheckingRouteTooltip(): string {
  return t`Checking route availability...`
}

export function getNoRouteTooltip(): string {
  return t`No route found for this token`
}
